import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const UpdateNotificationPreferencesMutation = graphql.persisted(
  "UpdateNotificationPreferences",
  graphql(`
    mutation UpdateNotificationPreferences($input: UpdateNotificationPreferencesInput!) {
      updateNotificationPreferences(input: $input) {
        user { id gradePostedEmailOptIn }
        userErrors { message path }
      }
    }
  `)
);

export { UpdateNotificationPreferencesMutation };

export function useUpdateNotificationPreferences() {
  return useMutation(UpdateNotificationPreferencesMutation);
}
